import {
  fetch
} from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'

/**
 * @param {Object} data
 * 列表列表
 */
export function getReceiveReminderList(data) {
  return fetch({
    url: '/financial/receive/reminder/pageList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 删除单据
 */
export function deleteReceiveReminder(data) {
  return fetch({
    url: '/financial/receive/reminder/delete',
    method: 'POST',
    data
  })
}

/**
 * @param {Object} data
 * 保存单据
 */
export function saveReceiveReminder(data) {
  return fetch({
    url: '/financial/receive/reminder/save',
    method: 'POST',
    data
  })
}





// WEBPACK FOOTER //
// ./src/api/ReceiveReminder/index.js